// --- Views
import TradeInMileageForm from '@/views/shared/TradeInMileageForm.vue';
import TradeInAmountOwingForm from '@/views/shared/TradeInAmountOwingForm.vue';
import ContactFormWrapper from '@/views/shared/ContactFormWrapper.vue';
import TradeInResults from '@/views/shared/TradeInResults.vue';
import ErrorView from '@/views/shared/ErrorPageV2.vue';
import CarfaxBasicForm from '@/components/shared/trade-in-carfax/CarfaxBasicForm.vue';
import CarfaxDetailsForm from '@/components/shared/trade-in-carfax/CarfaxDetailsForm.vue';

export default [
  {
    path: '',
    redirect: { path: 'carfax-basic-form' },
  },
  {
    path: 'carfax-basic-form',
    component: CarfaxBasicForm,
    meta: {
      headerIcon: 'back',
      currentStep: 1,
      navInfo: {
        from: 0,
        to: 1,
      },
      numberOfSteps: 6,
      hasNext: true,
      nextRoutePath: 'carfax-details-form',
    },
  },
  {
    path: 'carfax-details-form',
    component: CarfaxDetailsForm,
    meta: {
      headerIcon: 'back',
      currentStep: 2,
      navInfo: {
        from: 1,
        to: 2,
      },
      numberOfSteps: 6,
      hasNext: true,
      nextRoutePath: 'trade-in-mileage',
    },
  },
  {
    path: 'trade-in-mileage',
    component: TradeInMileageForm,
    meta: {
      headerIcon: 'back',
      currentStep: 3,
      navInfo: {
        from: 2,
        to: 3,
      },
      numberOfSteps: 6,
      hasNext: true,
      nextRoutePath: 'trade-in-amount-owing-form',
    },
  },
  {
    path: 'trade-in-amount-owing-form',
    component: TradeInAmountOwingForm,
    meta: {
      headerIcon: 'back',
      currentStep: 4,
      navInfo: {
        from: 3,
        to: 4,
      },
      numberOfSteps: 6,
      hasNext: true,
    },
  },
  {
    path: 'trade-in-contact-form',
    component: ContactFormWrapper,
    meta: {
      headerIcon: 'back',
      currentStep: 5,
      navInfo: {
        from: 4,
        to: 5,
      },
      numberOfSteps: 6,
      hasNext: true,
    },
  },
  {
    path: 'trade-in-results',
    component: TradeInResults,
    meta: {
      headerIcon: false,
      currentStep: 6,
      v2FooterStyleClasses: 'grey',
      hasNext: true,
    },
  },
  {
    path: 'trade-in-error',
    component: ErrorView,
    meta: {
      headerIcon: false,
      navInfo: false,
      hasNext: true,
      errorPayload: {
        errorType: 'trade',
        errorMsg: 'default',
        buttonText: 'returnCal',
      },
    },
  },
  // Subflow general error route
  {
    path: 'error',
    component: ErrorView,
    meta: {
      headerIcon: false,
      navInfo: false,
      hasNext: true,
      errorPayload: {
        errorType: 'general',
        errorMsg: 'subFlow',
        buttonText: 'continuePayment',
      },
    },
  },
  {
    path: '*',
    redirect: { path: 'error' },
  },
];
